import { render, staticRenderFns } from "./FAQEdit.vue?vue&type=template&id=7355599a"
import script from "./FAQEdit.vue?vue&type=script&lang=js"
export * from "./FAQEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports